import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

const BASE = '/messaggi-programmati'

export interface MessaggioProgrammato {
  id: number
  tipo: string
  destinatario_numero: string
  destinatario_nome?: string
  destinatario_cognome?: string
  customer_id?: number
  testo: string
  oggetto?: string
  ricorrenza: 'nessuna' | 'settimanale' | 'mensile' | 'annuale'
  data_primo_invio: string
  prossimo_invio: string
  ultimo_invio?: string
  invii_totali: number
  stato: 'attivo' | 'sospeso' | 'completato'
  creato_da_id?: number
  created_at: string
}

export interface MessaggioProgrammatoCreate {
  tipo?: string
  destinatario_numero: string
  destinatario_nome?: string
  destinatario_cognome?: string
  customer_id?: number
  testo: string
  oggetto?: string
  ricorrenza?: string
  data_primo_invio: string
}

export function useMessaggiProgrammati(stato?: string) {
  return useQuery({
    queryKey: ['messaggi-programmati', stato],
    queryFn: async () => {
      const res = await axiosInstance.get(BASE, { params: stato ? { stato } : {} })
      return res.data as MessaggioProgrammato[]
    },
  })
}

export function useCreateMessaggioProgrammato() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: MessaggioProgrammatoCreate) =>
      axiosInstance.post(BASE, data).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['messaggi-programmati'] }),
  })
}

export function useUpdateMessaggioProgrammato() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, ...data }: Partial<MessaggioProgrammato> & { id: number }) =>
      axiosInstance.put(`${BASE}/${id}`, data).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['messaggi-programmati'] }),
  })
}

export function useDeleteMessaggioProgrammato() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => axiosInstance.delete(`${BASE}/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['messaggi-programmati'] }),
  })
}

export function useInviaNowMessaggioProgrammato() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => axiosInstance.post(`${BASE}/${id}/invia-ora`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['messaggi-programmati'] }),
  })
}
